
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LiveWidgetDOM
 * @hideconstructor
 * @classdesc Implements LiveWidgetDOMAPI
 */
define([
	'./api/LiveWidgetDOMAPI',
	'jquery',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (LiveWidgetDOMAPI, $, APIFactory) => {
	class LiveWidgetDOM{

		constructor(options) {
			this._domNode = options.features.ContentViewDOM.getNode();
			this.providers = [];
		}

		getAPI() {
			if (!this._api) {
				this._api =  APIFactory.createAPI(this, [LiveWidgetDOMAPI]);
			}
			return this._api;
		}

		/**
		 * @implements LiveWidgetDOMAPI.getUIJSON
		 */
		getUIJSON() {
			let UIJSON = {
				widgetIcons: this._retrieveWidgetIcons(),
				title: this._retrieveTitle()
			};
			this.providers.forEach(provider => {
				Object.assign(UIJSON, provider.getUIJSON());
			});
			return UIJSON;
		}

		registerProvider(providerAPI) {
			this.providers.push(providerAPI);
		}

		_retrieveWidgetIcons() {
			const $widgetIcons = $(this._domNode).find('.widgetHeader div.widgetIcons .dataWidgetIcon');
			let icons = [];
			if ($widgetIcons.length) {
				$widgetIcons.each((index, icon)=>{
					const $icon = $(icon);
					const title = $icon.attr('title');
					const ariaLabel = $icon.attr('aria-label');
					if ($icon.is(':visible')){
						if(title && ariaLabel && (title===ariaLabel)){
							icons.push({
								label: title
							});
						} else icons.push ({ label: null });
					}
				});
			}
			return icons.length? icons : undefined;
		}

		_retrieveTitle() {
			const $title = $(this._domNode).find('.widgetHeader .widgetTitle .textArea');
			let title;
			if ($title && $title.length && $title.is(':visible')) {
				const $textNode = $title.find('span.textFitted p span');
				title = {
					value: $textNode.text(),
					fontSize: $textNode.css('font-size'),
					fontFamily: $textNode.css('font-family'),
					alignment: $textNode.css('text-align')
				};
			}
			return title;
		}
	}

	return LiveWidgetDOM;
});
